import 'bootstrap/dist/css/bootstrap.min.css';
import {systemConfiguration} from "../../../src/CommonImports";
import './../css/GPage3.css';

function GSignImg() {
    const sasToken = systemConfiguration.AZURE_FTP_GRASTECH3JOBS_SAAS_TOKEN;
    const mediaUrl = 'https://grastechftp.blob.core.windows.net/grastech3jobs/media/icons/';
    return (
       <div className="container">
                    <div className="box-newsletter position-relative rounded-end">
                        <h5 className="text-white fw-bold fs-3">Sign up to get</h5>
                        <h6 className="text-white fw-bold fs-1">the latest jobs</h6>

                        <div className="box-form-newsletter mt-4">
                            <form className="form-newsletter d-flex">
                                <input type="text" className="form-control input-newsletter flex-grow-1 me-2"
                                    placeholder="contact.info@grastech3solutions.com" />
                                <button type="submit"
                                    className="btn btn-default font-heading icon-send-letter">Subscribe</button>
                            </form>
                        </div>
                    </div>

                    <div className="box-newsletter-bottom">
                        <div className="newsletter-bottom mx-auto"></div>
                    </div>
            </div>

    )

}
export default GSignImg;